import { render } from "./TrialDepositsInit.vue?vue&type=template&id=84eb9b84&scoped=true"
import script from "./TrialDepositsInit.vue?vue&type=script&lang=js"
export * from "./TrialDepositsInit.vue?vue&type=script&lang=js"

import "./TrialDepositsInit.vue?vue&type=style&index=0&id=84eb9b84&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-84eb9b84"]])

export default __exports__